export default "__VITE_ASSET__BdSPNG5q__";